export default import.meta.ROLLDOWN_FILE_URL_XlzKyBDhsXxwmPcQu_LwOw